import * as React from 'react';
import { Bullseye, PageSection, Spinner } from '@patternfly/react-core';
import { useLocation } from 'react-router-dom';
import { isAuthenticated, loginCustomer } from './portalAuth';

interface ProtectedRouteProps {
  component: React.ComponentType;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ component: Component }) => {
  const [authState, setAuthState] = React.useState<'loading' | 'authenticated' | 'unauthenticated'>('loading');
  const location = useLocation();

  React.useEffect(() => {
    const checkAuth = async () => {
      try {
        const auth = await isAuthenticated();
        setAuthState(auth ? 'authenticated' : 'unauthenticated');
      } catch (error) {
        console.error('Auth check failed:', error);
        setAuthState('unauthenticated');
      }
    };
    checkAuth();
  }, []);

  React.useEffect(() => {
    if (authState !== 'unauthenticated') {
      return;
    }
    const targetPath = `${location.pathname}${location.search || ''}`;
    try {
      window.sessionStorage.setItem('postAuthRedirectPath', targetPath);
    } catch (e) {
      console.error('Failed to store post-auth redirect path', e);
    }
    void loginCustomer().catch((error) => {
      console.error('Microsoft sign-in failed:', error);
    });
  }, [authState, location.pathname, location.search]);

  if (authState === 'loading' || authState === 'unauthenticated') {
    return (
      <PageSection>
        <Bullseye>
          <Spinner
            size="lg"
            aria-label={authState === 'unauthenticated' ? 'Redirecting to sign-in' : 'Checking your session'}
          />
        </Bullseye>
      </PageSection>
    );
  }

  return <Component />;
};
